import React from "react";
import { LuEllipsis } from "react-icons/lu";

interface OverviewCardProps {
  type: string;
  count: number;
  date: string;
}

export const OverviewCard: React.FC<OverviewCardProps> = ({
  type,
  count,
  date,
}) => {
  const formattedType =
    type === "users"
      ? "Users & Admins"
      : type.charAt(0).toUpperCase() + type.slice(1);

  const LuEllipsisIcon = LuEllipsis as React.ElementType;

  const currentDate = new Date().toLocaleString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

  const getBackgroundColor = (type: string) => {
    switch (type) {
      case "users":
        return "bg-blue-50";
      case "posts":
        return "bg-green-50";
      case "applications":
        return "bg-purple-50";
      case "interviews":
        return "bg-orange-50";
      default:
        return "bg-white";
    }
  };

  return (
    <div
      className={`p-4 rounded-2xl shadow-sm border border-gray-100 flex flex-col space-y-1 ${getBackgroundColor(
        type
      )}`}
    >
      <div className="flex justify-between items-center">
        <div className="text-xs text-gray-500">{currentDate}</div>
        <LuEllipsisIcon className="text-gray-500" />
      </div>
      <p className="text-2xl font-semibold text-gray-800">{count}</p>
      <div className="flex items-center justify-between">
        <p className="text-sm text-gray-500">{formattedType}</p>
      </div>
    </div>
  );
};
